import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import ServiceCard from '../components/ServiceCard';
import { servicesData, companyInfo } from '../mock';

const HomePage = () => {
  const navigate = useNavigate();

  const handleWhatsAppClick = () => {
    window.open(companyInfo.whatsappLink, '_blank');
  };

  return (
    <div className="page-container">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <h1 className="hero-title">
            Sua TI Protegida. <br />Seu Negócio Focado.
          </h1>
          <p className="hero-subtitle">
            Soluções enterprise em cibersegurança e infraestrutura para empresas modernas
          </p>
          <button className="btn-primary" onClick={handleWhatsAppClick}>
            Fale Conosco
            <ArrowRight size={20} />
          </button>
        </div>
      </section>

      {/* Services Preview Section */}
      <section className="services-preview-section">
        <div className="section-header">
          <h2 className="section-title">Nossos Serviços</h2>
          <p className="section-subtitle">
            Soluções completas em tecnologia para proteger e impulsionar seu negócio
          </p>
        </div>
        <div className="services-grid">
          {servicesData.map((service) => (
            <ServiceCard key={service.id} service={service} />
          ))}
        </div>
        <div className="section-cta">
          <button className="btn-secondary" onClick={() => navigate('/servicos')}>
            Ver Todos os Serviços
            <ArrowRight size={20} />
          </button>
        </div>
      </section>
    </div>
  );
};

export default HomePage;